<template>
  <div>
    <div v-if="vehicle">
      <page-header>
        <template #title>
          <h1 class="page-title">View Vehicle</h1>
        </template>
        <template #actions>
          <page-header-action
            tag="router-link"
            variant="danger"
            :to="`/defleet/${vehicle.identifier}`"
          >
            Defleet
          </page-header-action>
          <page-header-action
            tag="form-button"
            @clicked="requestPdi"
            v-if="vehicle?.status?.name !== 'awaiting_pdi'"
          >
            Request PDI
          </page-header-action>
          <page-header-action tag="form-button" @clicked="toggleNotes">
            Notes
          </page-header-action>
        </template>
      </page-header>

      <div
        class="alert alert-info text-center"
        v-if="vehicle.status?.name == 'defleeted'"
      >
        <p><strong>Vehicle Defleeted</strong></p>
        <span v-if="vehicle.defleeted_at"
          >Defleeted At - {{ vehicle.defleeted_at | date }} -
        </span>
        <span v-if="vehicle.defleeted_by"
          >Defleeted By - {{ vehicle.defleeted_by.full_name }} -
        </span>
        <span v-if="vehicle.defleet_reason"
          >Defleeted Reason - {{ vehicle.defleet_reason.label }}</span
        >
      </div>

      <div class="card mb-3">
        <form-navigation-tabs
          :tabs="tabs"
          :active="active"
          @selected="setActiveTab"
        ></form-navigation-tabs>

        <vehicle-details
          :vehicle="vehicle"
          v-if="active === 'details'"
        ></vehicle-details>

        <hire-history
          :vehicle="vehicle"
          v-if="active === 'hire_history'"
        ></hire-history>

        <jobs :vehicle="vehicle" v-if="active === 'jobs'"></jobs>

        <pdi-history
          :vehicle="vehicle"
          v-if="active === 'pdi_history'"
        ></pdi-history>

        <penalty-history
          :vehicle="vehicle"
          v-if="active === 'penalties'"
        ></penalty-history>

        <documents
          :vehicle="vehicle"
          :user="user"
          v-if="active === 'documents'"
        ></documents>
      </div>

      <vehicle-notes
        :vehicle="vehicle"
        :show="showNotes"
        @saved="addNote"
        @closed="closeNotes"
      ></vehicle-notes>
    </div>
    <div v-else>
      <preloader></preloader>
    </div>
  </div>
</template>

<script>
import VehicleDetails from '@/components/Modules/Fleet/Tabs/VehicleDetails';
import HireHistory from '@/components/Modules/Fleet/Tabs/HireHistory';
import Jobs from '@/components/Modules/Fleet/Tabs/Jobs';
import PenaltyHistory from '@/components/Modules/Fleet/Tabs/PenaltyHistory';
import PdiHistory from '@/components/Modules/Fleet/Tabs/PDIHistory';
import VehicleNotes from '@/components/Modules/Fleet/Children/VehicleNotes';
import Documents from '@/components/Modules/Fleet/Tabs/Documents';
import PageHeader from './../Shared/PageHeader.vue';
import PageHeaderAction from './../Shared/PageHeaderAction.vue';

export default {
  props: {
    identifier: {
      type: String
    }
  },

  components: {
    PageHeader,
    PageHeaderAction,
    VehicleDetails,
    HireHistory,
    PdiHistory,
    PenaltyHistory,
    Jobs,
    VehicleNotes,
    Documents
  },

  data() {
    return {
      vehicle: null,
      active: 'details',
      tabs: [
        {
          name: 'details',
          label: 'Details',
          disabled: false
        },
        {
          name: 'hire_history',
          label: 'Hire History',
          disabled: false
        },
        {
          name: 'jobs',
          label: 'Jobs',
          disabled: false
        },
        {
          name: 'pdi_history',
          label: 'PDI History',
          disabled: false
        },
        {
          name: 'penalties',
          label: 'Penalties',
          disabled: false
        },
        {
          name: 'documents',
          label: 'Documents',
          disabled: false
        }
      ],
      indicator: false,
      showNotes: false
    };
  },

  computed: {
    user() {
      return this.$store.getters.user;
    }
  },

  mounted() {
    this.loadVehicle();
  },

  methods: {
    loadVehicle() {
      if (!this.vehicle && this.user?.tenant?.identifier) {
        window.Ajax.get(
          `/fleet/${this.user?.tenant?.identifier}/${this.identifier}`
        )
          .then(response => (this.vehicle = response.data))
          .catch(error => {
            window.toastify.error(
              'Error',
              'An error occurred while loading the vehicle'
            );
          });
      }
    },

    setActiveTab(tab) {
      this.active = tab;
    },

    sendToDefleetView() {
      this.indicator = true;
      this.sendToRoute(this.identifier);
    },

    sendToRoute(identifier) {
      this.$router.push(`/fleet/${identifier}/defleet`);
    },

    requestPdi() {
      if (this.vehicle.status?.name !== 'awaiting_pdi') {
        window
          .swal({
            title: 'Are you sure?',
            text: 'Are you sure you want to request a PDI for that vehicle?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes'
          })
          .then(() => {
            window.Ajax.post('/pdi', { vehicle_id: this.vehicle.id })
              .then(response => {
                window.toastify.success(
                  'Success!',
                  'The vehicle has been added to the PDI queue'
                );

                this.vehicle = null;

                this.loadVehicle();
              })
              .catch(error => {
                window.toastify.error(
                  'Error',
                  'An error occurred while requesting the PDI'
                );
              });
          });
      }
    },

    toggleNotes() {
      this.showNotes = !this.showNotes;
    },

    addNote(note) {
      this.vehicle.notes.push(note);
    },

    closeNotes() {
      this.showNotes = false;
    }
  },

  watch: {
    user() {
      this.loadVehicle();
    }
  }
};
</script>
